import React from 'react';

import RouteIfRights from 'pages/router/RouteIfRights';

import SuppliersIframe from '.';

export const paths = {
  suppliers: '/inventory/suppliers',
};

export default [
  <RouteIfRights
    exact
    path={paths.suppliers}
    component={SuppliersIframe}
    key={paths.suppliers}
    rights="vendors"
    modules="inventory.vendor_catalog.v2"
  />,
];
